<template>
  <div>
    <!-- Breadcrumb start -->
    <section class="bradcrumb_sec">
      <div class="container-fluid custome_container">
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="bread_crumb_box d-md-flex align-items-start justify-content-between">
              <div class="">
                <h2 class="heading_2 font_bold mb_23">
                  Setup <span class="text_primary">guidelines</span>
                </h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link
                        class="navbar-brand m-0 p-0"
                        :to="{ name: 'user_home' }"
                      >
                        Home
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Setup Guidelines
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <h3
                class="heading_3 font_bold mb_23 text-center"
                v-if="
                 client_type === '4' && (setup_guidelines_heading || '').trim().length > 0
               "
              >
                {{ setup_guidelines_heading }}
              </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Breadcrumb end -->
    <section
      :class="
        !show_self_assessment_block
          ? 'work_from_office setup_guidline how_else_ergo mb-0'
          : 'work_from_office setup_guidline how_else_ergo'
      "
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xxl-12">
            <div class="row">
              <div
                v-for="(option, index) in setup_guidelines_options"
                :key="index"
                class="col-md-6 col-lg-4"
              >
                <div class="custome_card card2 border-0">
                  <router-link
                    :to="{ name: guidelineContentMap[option].route }"
                  >
                    <img
                      :src="guidelineContentMap[option].image"
                      alt="img"
                      class="mb_66"
                    />
                    <div class="card2_text_box">
                      <h5
                        class="font_bold text-center font_size_26 mb_20 text_black"
                      >
                        {{ guidelineContentMap[option].title }}
                      </h5>
                      <p class="text-center font_size_18 mb_20 text_black">
                        {{ guidelineContentMap[option].description }}
                      </p>
                      <p class="text_balticsea font_size_14 text_black">
                        5 minute journey
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="take_an_ergonomic_parttwo mb_44"
      v-show="show_self_assessment_block"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xxl-10">
            <div class="ergonomic-image pt_26 pb_26">
              <div class="overlay">
                <div class="row">
                  <div class="col-md-12 col-lg-7 col-xl-6">
                    <div class="left-section pr_60 pl_60">
                      <h6 class="sub_heading_1 font_bold mb_22 text-white">
                        Need more help?
                      </h6>
                      <p class="text-white p_20 mb_54">
                        Take a self-assessment today and see how ergo can help
                        you feel better and work smarter.
                      </p>
                      <div class="mt_14">
                        <router-link
                          :to="{ name: 'self_assessment_signup' }"
                          class="btn btn_secondary font_size_16"
                          >Take a Self-Assessment</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_self_assessment_block: true,
      setup_guidelines_options: [],
      setup_guidelines_heading: "",
      client_type: "1",
      guidelineContentMap: {
        "Seating": {
          route: "seating",
          image: require("../assets/images/setup_guidline/setup_guidline5.png"),
          title: "Seating",
          description:
            "Ergo has your back (literally) no matter where you sit.",
        },
        "Desk": {
          route: "desk",
          image: require("../assets/images/setup_guidline/setup_guidline4.png"),
          title: "Desk",
          description: "Learn to set yourself up well at any desk you use.",
        },
        "Desktop items": {
          route: "desktop_items",
          image: require("../assets/images/setup_guidline/setup_guidline3.png"),
          title: "Desktop items",
          description:
            "How and what you place on your desk impacts your work style.",
        },
        "Screens": {
          route: "screens",
          image: require("../assets/images/setup_guidline/setup_guidline2.png"),
          title: "Screens",
          description: "Wanna have great posture and be productive? Learn how.",
        },
        "Accessories": {
          route: "accessories",
          image: require("../assets/images/setup_guidline/setup_guidline1.png"),
          title: "Accessories",
          description:
            "It’s all in the details. Learn how accessories can help.",
        },
        "Lighting": {
          route: "lighting",
          image: require("../assets/images/setup_guidline/setup_guidline6.png"),
          title: "Lighting",
          description:
            "Learn how to use light to improve your output and avoid eyestrain.",
        },
      },
    };
  },
  name: "Setup_guidline",
  mounted() {
    document.title = "PBErgo - " + this.$router.currentRoute.meta.page_title;
    let data = this.$store.getters["auth/authUser"];
    let company_data = data.client;
    this.client_type = company_data.client_type;
    this.setup_guidelines_heading =
      company_data.essentials.setup_guidelines_heading;
    this.setup_guidelines_options = JSON.parse(
      company_data.essentials.setup_guidelines_options || "[]"
    );

    if (company_data.site_menu_details.TakeASelfAssessment.status == 0) {
      this.show_self_assessment_block = false;
    }
  },
};
</script>
